import { STORE_SETTINGS } from "../constants"

// eslint-disable-next-line import/prefer-default-export
export const storeSettings = (settings) => ({
  type: STORE_SETTINGS,
  settings,
})
